import { isChinese } from './isChinese';

export function countChinese(str: string) {
  return str.split('').filter(isChinese).length;
}
